import { ErrorHandler } from '@angular/core';
import * as Sentry from '@sentry/angular';

// Not an Angular-DI service: constructed manually via `new` in app.config.ts's
// provideErrorHandler() factory, so it takes its delegate as a plain constructor argument.
export class ReloadOnChunkErrorHandler implements ErrorHandler {
  private static readonly RELOAD_FLAG_KEY = '__chunk_reload_attempted';

  constructor(private delegate?: ErrorHandler) {}

  handleError(error: any): void {
    const message: string = error?.message || '';
    const isChunkFailure =
      message.includes('Failed to fetch dynamically imported module') ||
      message.includes('Loading chunk') ||
      message.includes('imported module script') ||
      // Handle MIME type errors (HTML returned instead of JS after deployment)
      message.includes('is not a valid JavaScript MIME type') ||
      message.includes("Unexpected token '<'") || // HTML returned instead of JS
      message.includes('text/html') ||
      // Handle network errors for JS files
      (message.includes('Failed to fetch') && (error?.stack || '').includes('.js'));

    if (isChunkFailure) {
      try {
        const alreadyTried = sessionStorage.getItem(ReloadOnChunkErrorHandler.RELOAD_FLAG_KEY);
        if (!alreadyTried) {
          sessionStorage.setItem(ReloadOnChunkErrorHandler.RELOAD_FLAG_KEY, '1');
          console.warn('[PWA] Chunk/asset load failure detected – reloading application…');
          location.reload();
          return; // stop propagation; page is reloading
        } else {
          console.error('[PWA] Reload already attempted, not reloading again to avoid loop');
        }
      } catch (_) {
        // sessionStorage might be unavailable (private mode etc.)
        location.reload();
        return;
      }
    }

    // Forward to delegate if provided, else to Sentry / console
    if (this.delegate) {
      this.delegate.handleError(error);
      return;
    }

    if (Sentry && Sentry.captureException) {
      Sentry.captureException(error);
    } else {
      console.error(error);
    }
  }
}
